'use client'

// lib files
import { usePersonalizedResourceFetch } from '@/lib/hooks/usePersonalizedResource';
import { continueWatching } from '@/lib/resources/continue-watching';

function NetworkMyListContinueWatching() {
  usePersonalizedResourceFetch(continueWatching)

  return (<></>)
}

export default NetworkMyListContinueWatching
